import _round from 'lodash/round'; // there are at least 5 ways to convert string to number.
// the methods below are chosen becuase of performance and most edge cases handled.
// ref: https://coderwall.com/p/5tlhmw/converting-strings-to-number-in-javascript-pitfalls
// parseFloat is chosen because it, along with isNaN and isFinite
// handle the most edge cases when tested with typical
// javascript datatypes and values.

var toNumber = function toNumber(value) {
  if (isNumeric(value)) {
    return parseFloat(value);
  } else {
    throw new Error("Connot convert ".concat(value, " to a number. use a valid number for conversion."));
  }
};

var isNumeric = function isNumeric(value) {
  return !window.isNaN(parseFloat(value)) && window.isFinite(value);
};

var round = function round(value, decimals) {
  if (!isNumeric(value)) {
    return null;
  }

  var number = toNumber(value);
  return _round(number, decimals);
};

var padNumberLeft = function padNumberLeft(value) {
  if (!isNumeric(value)) {
    return null;
  }

  var number = toNumber(value);
  return number < 10 ? "0".concat(number) : "".concat(number);
};

export { isNumeric, toNumber, round, padNumberLeft };